import { useState } from 'react';
import apiCall from '../../utility/api';
import axios from 'axios';
const REACT_APP_STORAGE_API_BASE = 'https://react-test.nanoheal.work/storage/api';
const REACT_APP_CHUNK_SIZE = 10 * 1024 * 1024; // 10MB chunks
const REACT_APP_MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1GB

export interface FileData {
  Key: string;
  LastModified: string;
  Size: number;
}


    /**
     * Retrieves a storage token from the server.
     * 
     * This function makes an API call to fetch a storage token. If successful,
     * it returns an object containing the token. If the API call fails or
     * returns an unsuccessful status, it throws an error or returns null.
     * 
     * @returns {Promise<{ token: string } | null>} An object containing the storage token if successful, or null if an error occurs.
     * @throws {Error} Throws an error if the API call is successful but no token is returned.
     */
   export const getStorageToken = async () => {
        try {
            const { token, status } = await apiCall('/getStorageToken', '', 'GET');

            if (status === 'success' && token) {
                return { token: token };
            }

            // throw new Error('Failed to obtain storage token');
        } catch (error) {
            console.error('Error getting storage token:', error);
            return null;
        }
    };

    /**
     * Uploads a file to the server.
     * 
     * This function uploads a file to the server using the provided API endpoint.
     * It checks if the file size is within the allowed limit before uploading.
     * 
     * @param file - The File object to be uploaded.
     * @param uploadPath - The path where the file should be uploaded (currently unused in the function).
     * @param token - The authentication token required for the upload.
     * @returns A Promise that resolves to the parsed JSON response from the server.
     * @throws {Error} If the file size exceeds the maximum allowed size (1GB).
     */
    export const uploadFile = async (
        file: File,
        uploadPath: string,
        token: string,
        onProgress: (progress: number) => void
    ) => {
        const formData = new FormData();
        formData.append('file', file);
    
        // Set initial progress
        onProgress(0);
    
        const response = await axios.post(
            `${REACT_APP_STORAGE_API_BASE}/upload?folder=${uploadPath}&token=${token}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        const percentComplete = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        // Ensure we never report 100% until the server responds
                        onProgress(Math.min(percentComplete, 99));
                    }
                },
            }
        );
    
        // Only set to 100% after we get successful response
        if (response.data.message === "Good") {
            onProgress(100);
        }
    
        return response.data;
    };


    /**
     * Fetches table data from the server.
     * 
     * This function makes an API call to retrieve a list of data, presumably for populating a table.
     * It uses the provided authentication token to make an authorized request.
     *
     * @param token - The authentication token required for the API request.
     * @returns A Promise that resolves to the parsed JSON response from the server, or an error if the request fails.
     * @throws {Error} If the HTTP response is not successful (status code is not in the 200-299 range).
     */
//    export const fetchS3Data = async (token: string) => {
//         try {
//             const response = await fetch(
//                 `${REACT_APP_STORAGE_API_BASE}/getList`,
//                 {
//                     headers: {
//                         'x-auth-token': token,
//                         'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
//                     },
//                     method: 'GET',
//                 }
//             );

//             // Parse the response as JSON
//             const data = await response.json();
//             // const data =  await apiCall('/softDist/getFiles')
//             return data;
//         } catch (error) {
//             return error;
//         }
//     };
    export const fetchS3Data = async (token: string, folderPath: string ) => {
        try {
            // Construct the path - note the lack of leading/trailing slashes
            // const folderPath = '/SWD';
            const encodedPath = encodeURIComponent(folderPath);
            
            const response = await fetch(
                `${REACT_APP_STORAGE_API_BASE}/getFolderFilesList?path=${encodedPath}`,
                {
                    headers: {
                        'x-auth-token': token,
                        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    },
                    method: 'GET',
                }
            );
    
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching S3 data:', error);
            throw error;
        }
    };

    /**
     * Deletes a file from the server.
     * 
     * This function attempts to delete a specified file from the server using an API call.
     * It requires a valid storage token to authorize the request.
     * 
     * @param fileName - The name of the file to be deleted.
     * @returns A Promise that resolves when the file is successfully deleted, or logs an error if the deletion fails.
     */
    export const deleteFunction = async (token: string, fileName: string, filePath: string = '')  => {
        // const {token} = await getStorageToken();
        console.log('filePath', filePath);
        console.log('token', token);
        console.log('fileName', fileName);
        try {
            const bodyParams = new URLSearchParams();
            bodyParams.append('fileName', fileName);
            if (filePath) {
                bodyParams.append('filePath', filePath);
            }
            const response = await fetch(
                `${REACT_APP_STORAGE_API_BASE}/deleteFile`,
                {
                    headers: {
                        'x-auth-token': token,
                        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    },
                    body: bodyParams.toString(),
                    method: 'POST',
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
        } catch (error) {
            console.error('Unable to delete file, try again later');
        }
    }
